import once from 'lodash/once';
import over from 'lodash/over';
import on from './on';
import { map } from './iterate';



export default (elements, callback) =>
  once(over(map(elements, (element) => on(element, 'click', (ev) => {
    const href = element.href;
    const searchParams = new URLSearchParams(window.location.href);

    if (href) {
      ev.preventDefault();
      ev.stopPropagation();
    }

    if (searchParams.get('disable_links')) {
      return;
    }

    callback(ev, () => {
      if (!href) {
        return;
      }

      window.location.href = href;
    });
  }))));



// WEBPACK FOOTER //
// ./src/lib/dom/on-link-click.js